import React from "react";
import { useDispatch } from "react-redux";
import { parseAction } from "../../../../actions/REST";
import config from "../../../../config";
import { updateUser } from "../../../../actions/ProfileAction";
import "../../../TabList/ProfileSetting/ProfileSetting.css";

const AwayConfirmationModal = ({
    openUserSched = () => {},
    onClose = () => {},
}) => {
  const dispatch = useDispatch();

  const handleClose = () => {
    const today = new Date().toISOString().slice(0, 10); // Format: YYYY-MM-DD
    localStorage.setItem('awayLastShownDate', today);
    onClose();
  };

  const openSchedule = () => {
    const today = new Date().toISOString().slice(0, 10); // Format: YYYY-MM-DD
    localStorage.setItem('awayLastShownDate', today);
    openUserSched();
    // handleClose();
  };

  const setToAvailable = () => {
    const params = {
      isAvailable: true,
      useSchedule: false,
      unavailabilityReason: "",
    }
    parseAction("post", config.BASE_URL + "/parse/functions/updateAvailability", params,
      { "Content-Type": "application/json" }
    )
    .then((result) => {
      dispatch(updateUser(params));
      handleClose();
      // return result;
    })
    .catch((error) => {
      console.error(error);
      return error;
    });
  }

  return (
    <div className="user-status-confirmation-modal">
      <div className="user-status-confirmation-container" style={{ width: "380px" }}>
        <div className="save-changes-flex">
          <div className="away-notification-header">
            Set your status to Available ?
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => handleClose()}
              style={{ marginRight: "5px" }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <span className="away-notification-sub">
            You're set to "Away." Switch to "Available" or set a weekly schedule.
          </span>
          <div className="away-footer">
            <a
              className="user-status-options"
              onClick={() => handleClose()}
            >
              No Thanks
            </a>
            <div className="ml-auto">
              <button
                type="button"
                className="btn-hubchart btn-hubchart-close btn-sm schedule-action-cancel"
                style={{ marginRight: "10px", color: "black" }}
                onClick={() => openSchedule()}
              >
                Set Schedule
              </button>
              <button
                type="button"
                className="btn-sm btn-hubchart btn-hubchart-primary schedule-reason-save"
                onClick={() => setToAvailable()}
              >
                Set to Available
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AwayConfirmationModal;
